export const PLATFORM_COOKIE_NAME = '__Host-member-view';

export function configuredApiUrl(service: 'platform' | 'octane') {
  const value =
    service === 'platform'
      ? process.env.API_URL || process.env.NEXT_PUBLIC_API_URL
      : process.env.NEXT_PUBLIC_OCTANE_URL;
  if (!value) return null;
  try {
    const parsed = new URL(value);
    if (parsed.username || parsed.password || parsed.search || parsed.hash)
      return null;
    if (
      parsed.protocol !== 'https:' &&
      !(parsed.protocol === 'http:' && parsed.hostname === 'localhost')
    )
      return null;
    if (!parsed.pathname.endsWith('/')) parsed.pathname += '/';
    return parsed;
  } catch {
    return null;
  }
}
